<script lang="ts">
  import Nav from "../Components/Dashboard/Nav.svelte";
  import StorefrontCard from "../Components/Dashboard/StorefrontCard.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { Storefront } from "app/javascript/shared/javascripts/types/Storefront";
  export let storefronts: Storefront[];
</script>

<span class="fizz-layout-storefront">
  {#each storefronts as storefront}
    {#if storefronts.length == 1}
      <Nav {storefront}></Nav>
    {/if}
    <main data-grid-area="main">
      {#if storefronts.length > 1}
        <Nav {storefront}></Nav>
      {/if}
      <StorefrontCard {storefront}></StorefrontCard>
    </main>
  {/each}
  <main data-grid-area="main">
    <section class="fizz-padded-border-top fizz-stack-32">
      <h3 class="fizz-heading-4">Storefront Guides</h3>
      <p class="fizz-text-medium fizz-stack-24"></p>

      <div class="fizz-flex-row-responsive fizz-stack-16">
        <div
          class="fizz-flex-row fizz-card-padded fizz-text-medium fizz-flex-item fizz-align-content-start"
        >
          <Icon type="Storefront" extraClassNames="fizz-icon-24" height="24" width="24"></Icon>
          <div>
            <h4 class="fizz-heading-4">Getting Started with Storefronts</h4>
            <p class="fizz-stack-16"
              >Learn how to best optimize your distributor destination on Provi.</p
            >

            <p
              ><a href="https://support.provi.com/s/article/how-do-i-create-a-storefront"
                >View our best practices</a
              ></p
            >
          </div>
        </div>

        <div
          class="fizz-flex-row fizz-card-padded fizz-text-medium fizz-flex-item fizz-align-content-start"
        >
          <Icon type="Image" extraClassNames="fizz-icon-24" height="24" width="24"></Icon>
          <div>
            <h4 class="fizz-heading-4">Creative Guidelines</h4>
            <p class="fizz-stack-16">Follow these guidelines to meet our content specifications.</p>

            <p
              ><a href="https://support.provi.com/s/topic/0TODn000000YINAOA4/storefronts"
                >Go to guides</a
              ></p
            >
          </div>
        </div>
      </div>
    </section>
  </main>
</span>
